/* =============================================================================
   HAKI /cart page — enhancement layer (sections/haki-cart-page.liquid).

   The page works without this file (server-rendered form). With it:
   - edits go through window.HakiCart (the drawer's optimistic store), so the page,
     the drawer and the header count never disagree;
   - the rewards band, the shipping line and the picks come from
     window.HakiCartTiers, the drawer's own tier engine (same A/B arm, same country
     filter, same USD -> presentment conversion). Nothing here re-derives tiers;
   - once a change settles, the section is re-fetched and [data-hkcp-body] swapped,
     so lines, pre-order dates and totals stay exactly what Liquid renders.
   Gifts are added/removed by the drawer controller (reconcileGifts), which runs on
   every page including this one. The page never writes a gift on its own, except
   to decline one the shopper removed (HakiCartTiers.declineGift).
   ============================================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-hkcp]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section-id');

  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[m]; }); }

  var CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  var T = null;            // window.HakiCartTiers
  var C = null;            // window.HakiCart
  var exposed = false;
  var lastBand = null;     // band text last drawn (null = not drawn yet)

  // ---- live region (page-only messages; cart totals are announced by the shared
  //      cart status region the drawer owns, so a change is never read twice) ----
  // Messages said within the same moment are read together ("Added X. You've unlocked
  // free shipping!"), not the last one alone.
  var sayBuf = [], sayT = null;
  function say(msg) {
    var el = $('[data-hkcp-status]');
    if (!el || !msg) return;
    sayBuf.push(msg);
    el.textContent = '';
    clearTimeout(sayT);
    sayT = setTimeout(function () { el.textContent = sayBuf.join(' '); sayBuf = []; }, 60);
  }

  // ===========================================================================
  // Tier math — thin wrappers over the drawer's engine
  // ===========================================================================
  function tiers() { return (T && T.tiers) || []; }
  function thr(t) { return T.tierThreshold(t); }
  function nextTier(paid) {
    var ts = tiers();
    for (var i = 0; i < ts.length; i++) if (paid < thr(ts[i])) return ts[i];
    return null;
  }
  // "$65.00" -> "$65" for the ladder labels (whole thresholds read cleaner).
  function moneyShort(c) { return T.money(c).replace(/[.,]00(?=\D*$)/, ''); }
  function lc1(s) { s = String(s || ''); return s.charAt(0).toLowerCase() + s.slice(1); }
  // Which tiers adding `price` (presentment cents) to a bag at `paid` would unlock.
  // Exported for tests/cart-page.test.js.
  function unlocksFor(paid, price) {
    return tiers().filter(function (t) { var x = thr(t); return paid < x && paid + price >= x; });
  }
  function promptHTML(paid) {
    var ts = tiers();
    var n = nextTier(paid);
    if (n) {
      return String(n.remainingText || '{amount} more for {label}.')
        .replace('{amount}', '<em>' + esc(T.money(thr(n) - paid)) + '</em>')
        .replace('{label}', esc(n.label));
    }
    var top = ts[ts.length - 1];
    if (top.type === 'free_product' && T.isSoldOut(top.giftVariantId)) return esc(top.label) + ': all gone for now';
    return '<em>' + String(top.reachedText || '{label} unlocked.').replace('{label}', esc(top.label)) + '</em>';
  }

  // ===========================================================================
  // Rewards band (rebuilt in place from the drawer's tiers)
  // ===========================================================================
  function renderBand(state) {
    var band = $('[data-hkcp-band]');
    var ts = tiers();
    if (!band) return;
    if (!ts.length) { band.hidden = true; return; }
    band.hidden = false;
    var paid = T.paidCents(state);
    var top = thr(ts[ts.length - 1]) || 1;
    var empty = !(state.items || []).length;
    var msg = $('[data-hkcp-msg]', band);
    if (empty) {
      var cur = window.Shopify && Shopify.currency && Shopify.currency.active;
      var usd = (cur && cur !== 'USD') ? ' USD' : '';
      msg.textContent = ts.map(function (t) { return t.label + ' at $' + Math.round(t.threshold / 100) + usd; }).join(' · ');
    } else {
      msg.innerHTML = promptHTML(paid);
    }
    // The prompt is not a live region (it would chatter on every render). When it
    // changes after the first draw, a shopper's action did it: "You've unlocked a
    // Free mystery hat!" must be heard, not only seen (4.1.3).
    var now = msg.textContent;
    if (lastBand !== null && now !== lastBand && !empty) say(now);
    lastBand = now;
    var pct = Math.max(0, Math.min(100, paid / top * 100));
    $('[data-hkcp-fill]', band).style.width = pct + '%';
    var mini = $('[data-hkcp-mini]'); if (mini) mini.style.width = pct + '%';
    var marks = $('[data-hkcp-marks]', band);
    marks.innerHTML = ts.map(function (t) {
      var x = thr(t), on = paid >= x, at = x / top * 100;
      return '<li class="hkcp-mk' + (on ? ' is-on' : '') + (at > 85 ? ' is-end' : '') + '" style="--at:' + at + '%">' +
        '<span class="hkcp-mk__dot" aria-hidden="true">' + (on ? CHECK : '') + '</span>' +
        '<span class="hkcp-mk__lbl">' + esc(t.label) + '<small>' + esc(moneyShort(x)) + '</small>' +
        '<span class="visually-hidden">' + (on ? ', unlocked' : ', locked') + '</span></span></li>';
    }).join('');
    fitMarks(band);
    // The bar is SEEN here, so this is the exposure (same call as the drawer's open()).
    if (!exposed) {
      exposed = true;
      try { if (window.hakiExp) window.hakiExp.expose('cart_tiers'); } catch (e) {}
    }
    // Phone bar: the prompt as plain text.
    var payMsg = $('[data-hkcp-pay-msg]');
    if (payMsg) payMsg.innerHTML = empty ? '' : promptHTML(paid);
  }

  // Two tiers close together (an A/B arm at $85 / $100) put their labels on top of each
  // other on a phone. Measure; if any two labels touch, drop every other one a row.
  function fitMarks(band) {
    band = band || $('[data-hkcp-band]');
    if (!band) return;
    band.classList.remove('is-stagger');
    var ls = $$('.hkcp-mk__lbl', band).map(function (l) { return l.getBoundingClientRect(); });
    var hit = ls.some(function (a, i) {
      return ls.some(function (b, j) { return j > i && a.right > b.left - 4 && b.right > a.left - 4; });
    });
    if (hit) band.classList.add('is-stagger');
  }

  // The inline check in the section hides the server band and shipping row while an A/B
  // arm is active (the server copy is the control). Show them once the arm is drawn.
  function unpend() { root.classList.remove('hkcp--pending'); }

  // Shipping row: the drawer's free-shipping tier for THIS shopper (country-filtered),
  // in presentment currency. No such tier (outside its countries) = checkout decides.
  function renderShipping(state) {
    var dd = $('[data-hkcp-ship]');
    if (!dd) { unpend(); return; }
    var ship = tiers().filter(function (t) { return t.type === 'free_shipping'; })[0];
    var paid = T.paidCents(state);
    dd.innerHTML = (ship && paid >= thr(ship))
      ? '<b class="hkcp-ok">' + esc(dd.getAttribute('data-free') || 'Free') + '</b>'
      : '<span class="hkcp-muted">' + esc(dd.getAttribute('data-later') || 'Calculated at checkout') + '</span>';
    unpend();
  }

  // ===========================================================================
  // Optimistic line edits
  // ===========================================================================
  var busy = false;
  function lineState(key) {
    return ((C.getState().items) || []).filter(function (i) { return i.key === key; })[0] || null;
  }
  function setBusyUI(on) {
    busy = on;
    // aria-disabled, not disabled: a disabled button drops keyboard focus to <body>.
    $$('[data-act]').forEach(function (b) { if (on) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); });
    var tot = $('[data-hkcp-total]'); if (tot) tot.closest('.hkcp-tot').setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function optimistic(state) {
    // Quantities + line prices from the store's local model, instantly.
    $$('.hkcp-line[data-key]').forEach(function (li) {
      var it = lineState(li.getAttribute('data-key'));
      var q = $('[data-hkcp-qty]', li);
      if (!it) { li.classList.add('is-leaving'); return; }
      if (q && q.textContent !== String(it.quantity)) q.textContent = String(it.quantity);
      var lp = $('[data-hkcp-line-price]', li);
      if (lp && lp.getAttribute('data-unit')) lp.textContent = T.money(Number(lp.getAttribute('data-unit')) * it.quantity);
    });
    var sub = $('[data-hkcp-subtotal]'); if (sub) sub.textContent = T.money(C.subtotalCents());
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-act]');
    if (!btn || !C || !root.contains(btn)) return;
    e.preventDefault();               // the no-JS submit path
    if (busy) return;
    var li = btn.closest('.hkcp-line'); if (!li) return;
    var key = li.getAttribute('data-key');
    var act = btn.getAttribute('data-act');
    var it = lineState(key); if (!it) return;
    focusIntent = { key: key, act: act };
    if (act === 'remove') {
      var gv = btn.getAttribute('data-gift-variant');
      if (gv) {
        // A gift changes neither the paid count nor the subtotal, so the drawer's
        // cart status says nothing: say it here.
        var nm = $('.hkcp-line__title', li);
        T.declineGift(gv, key);
        say((nm ? nm.textContent.trim() : 'Gift') + ' removed.');
      } else C.remove(key);
      return;
    }
    C.changeLine(key, it.quantity + (act === 'inc' ? 1 : -1));
  });

  // ===========================================================================
  // Settle -> re-fetch the section and swap the body (Liquid stays the source)
  // ===========================================================================
  var focusIntent = null;
  var fetchSeq = 0;
  // Lines AND the total: a discount code changes no key or quantity, only money, and
  // must still re-render the section. Same format as data-sig in the section.
  function sigOf(state) {
    return ((state && state.items) || []).map(function (i) { return i.key + ':' + i.quantity; }).join('|') +
      '|T' + ((state && state.total_price) || 0);
  }
  function bodyEl() { return $('[data-hkcp-body]'); }

  function captureFocus() {
    var ae = document.activeElement;
    var body = bodyEl();
    if (!ae || !body || !body.contains(ae)) return focusIntent;  // never steal focus on load
    var li = ae.closest && ae.closest('.hkcp-line');
    if (li && ae.getAttribute('data-act')) return { key: li.getAttribute('data-key'), act: ae.getAttribute('data-act') };
    if (ae.id) return { id: ae.id };
    return focusIntent || { h1: true };
  }
  function restoreFocus(f, oldKeys) {
    if (!f) return;
    var target = null;
    if (f.key) {
      var li = $('.hkcp-line[data-key="' + (window.CSS && CSS.escape ? CSS.escape(f.key) : f.key) + '"]');
      if (li) target = $('[data-act="' + f.act + '"]', li) || $('[data-act="remove"]', li);
      if (!target) {
        // The line is gone: the next line's Remove, else the previous one's, else the
        // empty-state link, else the heading.
        var idx = oldKeys.indexOf(f.key);
        var lines = $$('.hkcp-line[data-key]');
        var after = null, before = null;
        lines.forEach(function (l) {
          var k = oldKeys.indexOf(l.getAttribute('data-key'));
          if (k > idx && !after) after = l;
          if (k < idx && k !== -1) before = l;
        });
        var pick = after || before;
        if (pick) target = $('[data-act="remove"]', pick);
        if (!target) target = $('.hkcp-empty a');
      }
    } else if (f.id) {
      target = document.getElementById(f.id);
    }
    if (!target) target = $('[data-hkcp-h1]');
    if (target) try { target.focus({ preventScroll: !!f.key }); } catch (e) { target.focus(); }
  }

  function swapBody(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-hkcp-body]');
    var body = bodyEl();
    if (!fresh || !body) return;
    var f = captureFocus();
    var oldKeys = $$('.hkcp-line[data-key]').map(function (l) { return l.getAttribute('data-key'); });
    // Keep the LIVE code box too (like the checkout block below): its message ("We
    // couldn't find that code."), aria-invalid/aria-describedby, typed value, open
    // state and focus must survive the re-render that Apply itself triggers. A server
    // copy would arrive empty and silently drop all of it.
    var oldCode = $('[data-hkcp-code]');
    if (oldCode && fresh.querySelector('[data-hkcp-code]')) oldCode.parentNode.removeChild(oldCode);
    else oldCode = null;
    // Keep the LIVE checkout block: Shopify has already hydrated its wallet widget
    // (and Corso may have decorated the button). A server copy would arrive bare.
    var oldPay = $('[data-hkcp-pay]');
    var freshPay = fresh.querySelector('[data-hkcp-pay]');
    if (oldPay && freshPay) {
      ['[data-hkcp-pay-total]'].forEach(function (s) {
        var a = $(s, oldPay), b = freshPay.querySelector(s);
        if (a && b) a.textContent = b.textContent;
      });
      oldPay.parentNode.removeChild(oldPay);
    }
    body.innerHTML = fresh.innerHTML;
    body.setAttribute('data-sig', fresh.getAttribute('data-sig') || '');
    if (oldPay) {
      var slot = $('[data-hkcp-pay]');
      if (slot) slot.parentNode.replaceChild(oldPay, slot);
    }
    if (oldCode) {
      var cslot = $('[data-hkcp-code]');
      if (cslot) cslot.parentNode.replaceChild(oldCode, cslot);
    }
    enhanceBody();
    renderAll(C.getState());
    restoreFocus(f, oldKeys);
    focusIntent = null;
  }

  var refetchT = null;
  function refetchNow() { maybeRefetch(C.getState(), true); }
  function maybeRefetch(state, force) {
    var body = bodyEl(); if (!body) return;
    if (!force && sigOf(state) === body.getAttribute('data-sig')) { setBusyUI(false); return; }
    clearTimeout(refetchT);
    var seq = ++fetchSeq;
    refetchT = setTimeout(function () {
      var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart?section_id=' + encodeURIComponent(sectionId);
      fetch(url, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error(r.status)); })
        .then(function (html) {
          if (seq !== fetchSeq) return;           // a newer change owns the body now
          setBusyUI(false);
          swapBody(html);
        })
        .catch(function () { setBusyUI(false); });
    }, 120);
  }

  // ===========================================================================
  // "Close the gap" picks
  // ===========================================================================
  var recCache = null;     // products from HakiCart.recommendations
  var recFor = null;       // product id they were fetched for
  function pool() {
    var el = $('[data-hkcp-pool]');
    if (!el) return { series: '', seriesProducts: [], best: [] };
    try { return JSON.parse(el.textContent); } catch (e) { return { series: '', seriesProducts: [], best: [] }; }
  }
  // Apparel converts ~4x accessories as an add-on (Aftersell: 1.06% vs 0.25%), so
  // hats, socks and the rest only fill in after the clothes. Mystery boxes and
  // bundles are not add-ons.
  var NOT_ADDON = /mystery|bundle|gift card|gift/i;
  var ACCESSORY = /^(hat|cap|socks?|accessor|bag|tote|keychain|sticker|pin|patch|poster)/i;
  function isAccessory(p) { return ACCESSORY.test(String(p.type || '').trim()); }
  function variantsOf(p) { return (p.variants || []).filter(function (v) { return v && v.id; }); }
  function priceOf(p) {
    var vs = variantsOf(p).filter(function (v) { return v.available !== false; });
    var v = vs[0] || variantsOf(p)[0] || {};
    return Number(v.price != null ? v.price : p.price) || 0;
  }
  // Exported for tests: the ranking the module uses.
  function rankPicks(cands, ctx) {
    var seen = {};
    var list = cands.filter(function (p) {
      if (!p || !p.id || seen[p.id]) return false;
      seen[p.id] = true;
      if (p.available === false) return false;
      if (ctx.inBag[String(p.id)]) return false;
      if (NOT_ADDON.test(String(p.type || '')) || /mystery|\(\s*gift\s*\)/i.test(p.title || '')) return false;
      if (variantsOf(p).some(function (v) { return ctx.giftIds[String(v.id)]; })) return false;
      return true;
    });
    var gap = ctx.gap;
    function score(p) {
      var s = 0;
      if (!isAccessory(p)) s += 1000;                         // apparel first, always
      if (ctx.series && p.anime && p.anime === ctx.series) s += 200;
      if (gap > 0) {
        var pr = priceOf(p);
        if (pr >= gap) s += 100 - Math.min(99, (pr - gap) / 100); // closest over the gap
      }
      return s;
    }
    return list.map(function (p, i) { return { p: p, s: score(p), i: i }; })
      .sort(function (a, b) { return b.s - a.s || a.i - b.i; })
      .map(function (x) { return x.p; });
  }

  function pickHTML(p, paid) {
    var price = priceOf(p);
    var un = unlocksFor(paid, price);
    var eff = un.length ? 'Unlocks ' + un.map(function (t) { return lc1(t.label); }).join(' + ') : '';
    var title = T.displayTitle(p.title);
    var img = p.featured_image ? String(p.featured_image).replace(/^http:/, 'https:') : '';
    var vs = variantsOf(p);
    var opts = (p.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
    var single = vs.length === 1 && (!opts.length || opts[0] === 'Title');
    var oneOption = opts.length === 1 && opts[0] !== 'Title' && vs.length <= 10;
    var ctl;
    if (single) {
      ctl = '<button type="button" class="hkcp-size hkcp-size--add" data-add="' + vs[0].id + '"' + (vs[0].available === false ? ' disabled' : '') + ' aria-label="Add ' + esc(title) + ' to bag">Add</button>';
    } else if (oneOption) {
      ctl = vs.map(function (v) {
        return '<button type="button" class="hkcp-size" data-add="' + v.id + '"' + (v.available === false ? ' disabled' : '') +
          ' aria-label="Add ' + esc(title) + ', ' + esc(opts[0].toLowerCase()) + ' ' + esc(v.title) + (v.available === false ? ', sold out' : '') + '">' + esc(v.title) + '</button>';
      }).join('');
    } else {
      ctl = '<a class="hkcp-size hkcp-size--add" href="' + esc(p.url) + '">Choose options</a>';
    }
    return '<li class="hkcp-pick" data-pid="' + p.id + '">' +
      '<a class="hkcp-ph" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" width="200" height="200" loading="lazy">' : '') + '</a>' +
      '<div class="hkcp-pick__body">' +
        '<h3 class="hkcp-pick__nm"><a href="' + esc(p.url) + '">' + esc(title) + '</a></h3>' +
        '<p class="hkcp-pick__p">' + esc(T.money(price)) + (p.anime ? ' · ' + esc(p.anime) : '') + '</p>' +
        (eff ? '<p class="hkcp-pick__eff">' + esc(eff) + '</p>' : '') +
        '<div class="hkcp-sizes" role="group" aria-label="' + (oneOption ? esc(opts[0]) + ': ' : '') + esc(title) + '">' + ctl + '</div>' +
      '</div></li>';
  }

  // Exported for tests. Older drawer script (no giftVariantIds): fall back to the tiers.
  function pickGiftIds() {
    var ids = {};
    ((T && T.giftVariantIds) || []).forEach(function (id) { ids[String(id)] = true; });
    tiers().forEach(function (t) { if (t.giftVariantId) ids[String(t.giftVariantId)] = true; });
    return ids;
  }

  function renderPicks(state) {
    var sec = $('[data-hkcp-closer]');
    if (!sec) return;
    var items = (state.items || []);
    var paidLines = items.filter(function (i) { return !T.isGift(i); });
    if (!paidLines.length) { sec.hidden = true; return; }
    var pl = pool();
    var paid = T.paidCents(state);
    var n = nextTier(paid);
    var gap = n ? thr(n) - paid : 0;
    var inBag = {}; items.forEach(function (i) { inBag[String(i.product_id)] = true; });
    // Every gift, paused ones too: T.tiers leaves a paused gift out (it is not promised),
    // but its product must still never be offered as a pick.
    var giftIds = pickGiftIds();
    var cands = (recCache || []).concat(pl.seriesProducts || [], pl.best || []);
    var ranked = rankPicks(cands, { inBag: inBag, giftIds: giftIds, gap: gap, series: pl.series });
    // When everything is unlocked and the bag has a series, show only that series.
    if (!n && pl.series) {
      var same = ranked.filter(function (p) { return p.anime === pl.series; });
      if (same.length >= 2) ranked = same;
    }
    var picks = ranked.slice(0, 3);
    if (!picks.length) { sec.hidden = true; return; }
    var h = $('[data-hkcp-closer-h]', sec), sub = $('[data-hkcp-closer-sub]', sec);
    if (n) {
      h.textContent = n.type === 'free_shipping' ? 'Get to free shipping' : 'Get to your ' + lc1(n.label);
      sub.textContent = "You're " + T.money(gap) + ' away.';
    } else {
      var allSeries = pl.series && picks.every(function (p) { return p.anime === pl.series; });
      h.textContent = allSeries ? 'More from ' + pl.series : 'One more?';
      // No tiers at all for this shopper (every one paused or outside their country):
      // there is no tier to have hit, so say nothing.
      sub.textContent = tiers().length ? "You've hit every tier." : '';
    }
    sub.hidden = !sub.textContent;
    // Rebuilding the list destroys the button that has focus (a size the shopper just
    // pressed): put focus back on the same button, else on the module heading (2.4.3).
    var ae = document.activeElement;
    var had = ae && sec.contains(ae) ? (ae.getAttribute('data-add') || '#') : null;
    $('[data-hkcp-picks]', sec).innerHTML = picks.map(function (p) { return pickHTML(p, paid); }).join('');
    sec.hidden = false;
    if (had) focusPick(had);
  }

  function focusPick(id) {
    var b = id && id !== '#' ? $('[data-add="' + id + '"]') : null;
    var t = (b && !b.disabled) ? b : $('[data-hkcp-closer-h]');
    if (t) try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); }
  }

  function loadRecs(state) {
    var first = (state.items || []).filter(function (i) { return !T.isGift(i); })[0];
    var pid = first ? first.product_id : null;
    if (!pid || pid === recFor || !C.recommendations) return;
    recFor = pid;
    C.recommendations.get({ productId: pid, limit: 10 }).then(function (list) {
      recCache = list || [];
      renderPicks(C.getState());
    }, function () {});
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (!b || !C) return;
    if (b.disabled || b.getAttribute('aria-busy') === 'true') return;
    var card = b.closest('.hkcp-pick');
    var name = card ? $('.hkcp-pick__nm', card).textContent : '';
    b.setAttribute('aria-busy', 'true');
    var label = b.textContent;
    b.textContent = '…';
    C.add(Number(b.getAttribute('data-add')), 1).then(function () {
      say('Added ' + name + (b.classList.contains('hkcp-size--add') ? '' : ', ' + label) + ' to your bag.');
      // The card leaves the list on the re-render; land on the module heading.
      focusIntent = { id: 'hkcp-closer-h' };
    }, function (err) {
      // The list may have been rebuilt meanwhile: act on the live button, keep focus there.
      var live = $('[data-add="' + b.getAttribute('data-add') + '"]') || b;
      live.removeAttribute('aria-busy'); live.textContent = label;
      say((err && err.message) || "Couldn't add that. Try again.");
      if (root.contains(live)) focusPick(live.getAttribute('data-add'));
    });
  });

  // ===========================================================================
  // "Have a code?" — Shopify's cart discount API, with its own verdict
  // ===========================================================================
  function postCodes(codes) {
    return fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(new Error(r.status)); });
  }
  function wireCode() {
    var box = $('[data-hkcp-code]');
    if (!box) return;
    box.hidden = false;
    // The live box is carried across re-renders (swapBody): wire it once.
    if (box.getAttribute('data-wired')) return;
    box.setAttribute('data-wired', '1');
    var input = $('[data-hkcp-code-input]', box), msg = $('[data-hkcp-code-msg]', box), btn = $('[data-hkcp-code-apply]', box);
    // Tie an error to the field (3.3.1 / 4.1.2); clear it on any other outcome.
    function setInvalid(on) {
      if (on) { input.setAttribute('aria-invalid', 'true'); input.setAttribute('aria-describedby', 'hkcp-code-msg'); }
      else { input.removeAttribute('aria-invalid'); input.removeAttribute('aria-describedby'); }
    }
    function apply() {
      var code = String(input.value || '').trim();
      if (!code) { input.focus(); return; }
      btn.setAttribute('aria-busy', 'true');
      // The update below REPLACES the cart's codes, so it must start from the codes the
      // cart really holds. Before the store has loaded /cart.js it has none to offer:
      // load first rather than wipe a code the shopper added elsewhere.
      var st = C.getState() || {};
      var ready = Array.isArray(st.discount_codes) ? Promise.resolve(st) : C.refresh().then(function () { return C.getState() || {}; });
      ready.then(function (cur) {
        if (!Array.isArray(cur.discount_codes)) throw new Error('cart not loaded');
        var have = cur.discount_codes.map(function (d) { return d.code; })
          .filter(function (c) { return String(c).toUpperCase() !== code.toUpperCase(); });
        return postCodes(have.concat([code]));
      }).then(function (cart) {
        btn.removeAttribute('aria-busy');
        var mine = (cart.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === code.toUpperCase(); })[0];
        setInvalid(false);
        if (!mine) {
          // Shopify dropped it: no such code.
          msg.textContent = "We couldn't find that code.";
          msg.className = 'hkcp-code__msg is-err';
          setInvalid(true);
        } else if (mine.applicable) {
          msg.textContent = code.toUpperCase() + ' applied.';
          msg.className = 'hkcp-code__msg is-ok';
        } else {
          // Keep it. Shopify says "not applicable" for a code it can only judge at
          // checkout (a free-shipping code before there is an address), so removing it
          // here would throw away a good code. Checkout gives the final answer.
          msg.textContent = code.toUpperCase() + ' added. Checkout shows whether it applies.';
          msg.className = 'hkcp-code__msg';
        }
        focusIntent = { id: 'hkcp-code-input' };
        // A code changes totals, not lines: re-render even if the signature matches.
        return C.refresh().then(function () { refetchNow(); });
      }).catch(function () {
        btn.removeAttribute('aria-busy');
        msg.textContent = "Couldn't check that code. Try again, or add it at checkout.";
        msg.className = 'hkcp-code__msg is-err';
        setInvalid(true);
      });
    }
    btn.addEventListener('click', apply);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
  }

  // ===========================================================================
  // Phone bar: keep the page's last line clear of the fixed checkout bar
  // ===========================================================================
  function padForBar() {
    // Pad the BODY, not the section: the footer is below us, and at the very bottom of
    // the page the fixed bar would otherwise sit over its last row.
    var pay = $('[data-hkcp-pay]');
    var fixed = pay && getComputedStyle(pay).position === 'fixed';
    var h = fixed ? Math.ceil(pay.getBoundingClientRect().height) + 'px' : '';
    root.style.setProperty('--hkcp-bar-h', h || '0px');
    document.body.style.paddingBottom = h;
    // A focused control must not land under the bar (2.4.11).
    document.documentElement.style.scrollPaddingBottom = fixed ? (Math.ceil(pay.getBoundingClientRect().height) + 16) + 'px' : '';
  }

  // ===========================================================================
  // Express wallet: <shopify-accelerated-checkout-cart> reserves height for every
  // wallet even though CSS shows only the first (Shop Pay), leaving a tall gap.
  // Clip it to the visible button, retried across its async hydration. Same
  // approach as the drawer's fitAccelerated(); never clips below a real button.
  // ===========================================================================
  function fitWallet() {
    var acc = $('.hkcp-xp');
    if (!acc) return;
    var content = acc.querySelector('.dynamic-checkout__content') || acc;
    content.style.maxHeight = ''; content.style.overflow = '';
    var crect = content.getBoundingClientRect();
    var nodes = content.querySelectorAll('*'), btn = null;
    for (var i = 0; i < nodes.length; i++) {
      if (getComputedStyle(nodes[i]).display === 'none') continue;
      var r = nodes[i].getBoundingClientRect();
      if (r.height >= 36 && r.height <= 80 && r.width >= crect.width * 0.6) { btn = nodes[i]; break; }
    }
    if (btn) {
      var b = btn.getBoundingClientRect();
      var h = Math.ceil((b.top - crect.top) + b.height + 2);
      if (h >= 40) { content.style.maxHeight = h + 'px'; content.style.overflow = 'hidden'; }
    }
    padForBar();
  }
  var fitT = [];
  function scheduleFit() {
    fitT.forEach(clearTimeout);
    fitT = [300, 900, 1800, 3500].map(function (t) { return setTimeout(fitWallet, t); });
  }

  // ===========================================================================
  // wiring
  // ===========================================================================
  function enhanceBody() {
    root.classList.add('hkcp--js');
    if (C) wireCode();
    padForBar();
    scheduleFit();
  }

  function renderAll(state) {
    renderBand(state);
    renderShipping(state);
    renderPicks(state);
    loadRecs(state);
    padForBar();
  }

  function start() {
    T = window.HakiCartTiers; C = window.HakiCart;
    enhanceBody();
    C.subscribe(function (state) {
      if (!state || !state.items) return;
      // The store starts from a blank placeholder until /cart.js answers; every real
      // cart carries a token. Rendering the placeholder would flash an empty band and
      // re-fetch the section for nothing.
      if (!state.token) return;
      renderBand(state);
      renderShipping(state);
      if (state.busy) { setBusyUI(true); optimistic(state); return; }
      optimistic(state);
      renderShipping(state);
      maybeRefetch(state);
      renderPicks(state);
      loadRecs(state);
      padForBar();
    });
    window.addEventListener('resize', function () { scheduleFit(); padForBar(); fitMarks(); });
  }

  // haki-cart.js (the drawer, rendered after <main>) publishes HakiCartTiers; the
  // store primes itself. Wait for both, like the drawer waits for the store.
  function ready() { return window.HakiCart && window.HakiCartTiers; }
  if (ready()) start();
  else {
    var t = setInterval(function () { if (ready()) { clearInterval(t); start(); } }, 30);
    // Never leave the band hidden if the drawer's engine never arrives.
    setTimeout(function () { clearInterval(t); if (!ready()) unpend(); }, 10000);
  }

  // Test hook (tests/cart-page.test.js reads these out of the source).
  window.__hkcpTest = { unlocksFor: unlocksFor, rankPicks: rankPicks, sigOf: sigOf, pickGiftIds: pickGiftIds };
})();
